// Terra Draw mode names; "select" and "static" are always registered.
export const RECTANGLE_DRAW_MODE = "rectangle";
export const POLYGON_DRAW_MODE = "polygon";
export const CIRCLE_DRAW_MODE = "circle";
export const SELECT_DRAW_MODE = "select";
export const STATIC_DRAW_MODE = "static";
// Terra Draw registers its own built-in "static" mode last, overwriting ours,
// so the read-only render mode needs a different name.
export const READONLY_DRAW_MODE = "readonly";

export type DrawMode =
  | typeof RECTANGLE_DRAW_MODE
  | typeof POLYGON_DRAW_MODE
  | typeof CIRCLE_DRAW_MODE
  | typeof SELECT_DRAW_MODE
  | typeof STATIC_DRAW_MODE
  | typeof READONLY_DRAW_MODE;
